export default "__VITE_ASSET__BTPFUlCN__"